export const eyewearExampleData = () => {
  return {
    tryall: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 60287, date: '2019-04-08'},
          {count: 66171, date: '2019-04-15'},
          {count: 75211, date: '2019-04-22'},
          {count: 70737, date: '2019-04-29'},
          {count: 76217, date: '2019-05-06'},
          {count: 83155, date: '2019-05-13'},
          {count: 76710, date: '2019-05-20'},
          {count: 89146, date: '2019-05-27'},
          {count: 88758, date: '2019-06-03'},
          {count: 104855, date: '2019-06-10'},
          {count: 113892, date: '2019-06-17'},
          {count: 121824, date: '2019-06-24'},
          {count: 139372, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 89718,
          totalCount: 1166335,
        },
        data: [
          {count: 60287, date: '2019-04-08'},
          {count: 66171, date: '2019-04-15'},
          {count: 75211, date: '2019-04-22'},
          {count: 70737, date: '2019-04-29'},
          {count: 76217, date: '2019-05-06'},
          {count: 83155, date: '2019-05-13'},
          {count: 76710, date: '2019-05-20'},
          {count: 89146, date: '2019-05-27'},
          {count: 88758, date: '2019-06-03'},
          {count: 104855, date: '2019-06-10'},
          {count: 113892, date: '2019-06-17'},
          {count: 121824, date: '2019-06-24'},
          {count: 139372, date: '2019-07-01'},
        ],
        results: [
          {
            total: 369356,
            skuType: 'Eyewear',
            data: [
              {count: 18848, date: '2019-04-08'},
              {count: 21232, date: '2019-04-15'},
              {count: 23963, date: '2019-04-22'},
              {count: 22124, date: '2019-04-29'},
              {count: 23842, date: '2019-05-06'},
              {count: 26017, date: '2019-05-13'},
              {count: 23889, date: '2019-05-20'},
              {count: 27895, date: '2019-05-27'},
              {count: 27686, date: '2019-06-03'},
              {count: 33676, date: '2019-06-10'},
              {count: 36583, date: '2019-06-17'},
              {count: 39134, date: '2019-06-24'},
              {count: 44466, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    trylive: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 27048, date: '2019-04-08'},
          {count: 30122, date: '2019-04-15'},
          {count: 34233, date: '2019-04-22'},
          {count: 31737, date: '2019-04-29'},
          {count: 34196, date: '2019-05-06'},
          {count: 37308, date: '2019-05-13'},
          {count: 34416, date: '2019-05-20'},
          {count: 39996, date: '2019-05-27'},
          {count: 39822, date: '2019-06-03'},
          {count: 47732, date: '2019-06-10'},
          {count: 51846, date: '2019-06-17'},
          {count: 55457, date: '2019-06-24'},
          {count: 63438, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 40566,
          totalCount: 527352,
        },
        data: [
          {count: 27048, date: '2019-04-08'},
          {count: 30122, date: '2019-04-15'},
          {count: 34233, date: '2019-04-22'},
          {count: 31737, date: '2019-04-29'},
          {count: 34196, date: '2019-05-06'},
          {count: 37308, date: '2019-05-13'},
          {count: 34416, date: '2019-05-20'},
          {count: 39996, date: '2019-05-27'},
          {count: 39822, date: '2019-06-03'},
          {count: 47732, date: '2019-06-10'},
          {count: 51846, date: '2019-06-17'},
          {count: 55457, date: '2019-06-24'},
          {count: 63438, date: '2019-07-01'},
        ],
        results: [
          {
            total: 170464,
            skuType: 'Eyewear',
            data: [
              {count: 8492, date: '2019-04-08'},
              {count: 9998, date: '2019-04-15'},
              {count: 11284, date: '2019-04-22'},
              {count: 9968, date: '2019-04-29'},
              {count: 10742, date: '2019-05-06'},
              {count: 11722, date: '2019-05-13'},
              {count: 10763, date: '2019-05-20'},
              {count: 12568, date: '2019-05-27'},
              {count: 12474, date: '2019-06-03'},
              {count: 15858, date: '2019-06-10'},
              {count: 17227, date: '2019-06-17'},
              {count: 18428, date: '2019-06-24'},
              {count: 20939, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    tryphoto: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 33239, date: '2019-04-08'},
          {count: 36049, date: '2019-04-15'},
          {count: 40978, date: '2019-04-22'},
          {count: 39000, date: '2019-04-29'},
          {count: 42022, date: '2019-05-06'},
          {count: 45847, date: '2019-05-13'},
          {count: 42294, date: '2019-05-20'},
          {count: 49150, date: '2019-05-27'},
          {count: 48936, date: '2019-06-03'},
          {count: 57123, date: '2019-06-10'},
          {count: 62046, date: '2019-06-17'},
          {count: 66367, date: '2019-06-24'},
          {count: 75934, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 49153,
          totalCount: 638983,
        },
        data: [
          {count: 33239, date: '2019-04-08'},
          {count: 36049, date: '2019-04-15'},
          {count: 40978, date: '2019-04-22'},
          {count: 39000, date: '2019-04-29'},
          {count: 42022, date: '2019-05-06'},
          {count: 45847, date: '2019-05-13'},
          {count: 42294, date: '2019-05-20'},
          {count: 49150, date: '2019-05-27'},
          {count: 48936, date: '2019-06-03'},
          {count: 57123, date: '2019-06-10'},
          {count: 62046, date: '2019-06-17'},
          {count: 66367, date: '2019-06-24'},
          {count: 75934, date: '2019-07-01'},
        ],
        results: [
          {
            total: 198892,
            skuType: 'Eyewear',
            data: [
              {count: 10356, date: '2019-04-08'},
              {count: 11234, date: '2019-04-15'},
              {count: 12679, date: '2019-04-22'},
              {count: 12156, date: '2019-04-29'},
              {count: 13100, date: '2019-05-06'},
              {count: 14295, date: '2019-05-13'},
              {count: 13126, date: '2019-05-20'},
              {count: 15327, date: '2019-05-27'},
              {count: 15212, date: '2019-06-03'},
              {count: 17818, date: '2019-06-10'},
              {count: 19356, date: '2019-06-17'},
              {count: 20706, date: '2019-06-24'},
              {count: 23527, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    saveall: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 571, date: '2019-04-08'},
          {count: 603, date: '2019-04-15'},
          {count: 634, date: '2019-04-22'},
          {count: 639, date: '2019-04-29'},
          {count: 681, date: '2019-05-06'},
          {count: 826, date: '2019-05-13'},
          {count: 750, date: '2019-05-20'},
          {count: 783, date: '2019-05-27'},
          {count: 726, date: '2019-06-03'},
          {count: 860, date: '2019-06-10'},
          {count: 1013, date: '2019-06-17'},
          {count: 1064, date: '2019-06-24'},
          {count: 1200, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 796,
          totalCount: 10349,
        },
        data: [
          {count: 571, date: '2019-04-08'},
          {count: 603, date: '2019-04-15'},
          {count: 634, date: '2019-04-22'},
          {count: 639, date: '2019-04-29'},
          {count: 681, date: '2019-05-06'},
          {count: 826, date: '2019-05-13'},
          {count: 750, date: '2019-05-20'},
          {count: 783, date: '2019-05-27'},
          {count: 726, date: '2019-06-03'},
          {count: 860, date: '2019-06-10'},
          {count: 1013, date: '2019-06-17'},
          {count: 1064, date: '2019-06-24'},
          {count: 1200, date: '2019-07-01'},
        ],
        results: [
          {
            total: 4052,
            skuType: 'Eyewear',
            data: [
              {count: 226, date: '2019-04-08'},
              {count: 236, date: '2019-04-15'},
              {count: 260, date: '2019-04-22'},
              {count: 267, date: '2019-04-29'},
              {count: 286, date: '2019-05-06'},
              {count: 310, date: '2019-05-13'},
              {count: 287, date: '2019-05-20'},
              {count: 292, date: '2019-05-27'},
              {count: 290, date: '2019-06-03'},
              {count: 339, date: '2019-06-10'},
              {count: 405, date: '2019-06-17'},
              {count: 397, date: '2019-06-24'},
              {count: 458, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    savelive: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 282, date: '2019-04-08'},
          {count: 282, date: '2019-04-15'},
          {count: 307, date: '2019-04-22'},
          {count: 319, date: '2019-04-29'},
          {count: 339, date: '2019-05-06'},
          {count: 412, date: '2019-05-13'},
          {count: 374, date: '2019-05-20'},
          {count: 391, date: '2019-05-27'},
          {count: 362, date: '2019-06-03'},
          {count: 429, date: '2019-06-10'},
          {count: 500, date: '2019-06-17'},
          {count: 508, date: '2019-06-24'},
          {count: 578, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 391,
          totalCount: 5082,
        },
        data: [
          {count: 282, date: '2019-04-08'},
          {count: 282, date: '2019-04-15'},
          {count: 307, date: '2019-04-22'},
          {count: 319, date: '2019-04-29'},
          {count: 339, date: '2019-05-06'},
          {count: 412, date: '2019-05-13'},
          {count: 374, date: '2019-05-20'},
          {count: 391, date: '2019-05-27'},
          {count: 362, date: '2019-06-03'},
          {count: 429, date: '2019-06-10'},
          {count: 500, date: '2019-06-17'},
          {count: 508, date: '2019-06-24'},
          {count: 578, date: '2019-07-01'},
        ],
        results: [
          {
            total: 1953,
            skuType: 'Eyewear',
            data: [
              {count: 110, date: '2019-04-08'},
              {count: 99, date: '2019-04-15'},
              {count: 121, date: '2019-04-22'},
              {count: 134, date: '2019-04-29'},
              {count: 143, date: '2019-05-06'},
              {count: 155, date: '2019-05-13'},
              {count: 143, date: '2019-05-20'},
              {count: 146, date: '2019-05-27'},
              {count: 145, date: '2019-06-03'},
              {count: 170, date: '2019-06-10'},
              {count: 199, date: '2019-06-17'},
              {count: 178, date: '2019-06-24'},
              {count: 211, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    savephoto: {
      request: {
        begin: '2019-04-08',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 289, date: '2019-04-08'},
          {count: 321, date: '2019-04-15'},
          {count: 327, date: '2019-04-22'},
          {count: 321, date: '2019-04-29'},
          {count: 341, date: '2019-05-06'},
          {count: 414, date: '2019-05-13'},
          {count: 376, date: '2019-05-20'},
          {count: 393, date: '2019-05-27'},
          {count: 364, date: '2019-06-03'},
          {count: 431, date: '2019-06-10'},
          {count: 513, date: '2019-06-17'},
          {count: 557, date: '2019-06-24'},
          {count: 621, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-04-08',
          untilTime: '2019-07-01',
          avgNewCount: 405,
          totalCount: 5268,
        },
        data: [
          {count: 289, date: '2019-04-08'},
          {count: 321, date: '2019-04-15'},
          {count: 327, date: '2019-04-22'},
          {count: 321, date: '2019-04-29'},
          {count: 341, date: '2019-05-06'},
          {count: 414, date: '2019-05-13'},
          {count: 376, date: '2019-05-20'},
          {count: 393, date: '2019-05-27'},
          {count: 364, date: '2019-06-03'},
          {count: 431, date: '2019-06-10'},
          {count: 513, date: '2019-06-17'},
          {count: 557, date: '2019-06-24'},
          {count: 621, date: '2019-07-01'},
        ],
        results: [
          {
            total: 2098,
            skuType: 'Eyewear',
            data: [
              {count: 116, date: '2019-04-08'},
              {count: 137, date: '2019-04-15'},
              {count: 139, date: '2019-04-22'},
              {count: 134, date: '2019-04-29'},
              {count: 143, date: '2019-05-06'},
              {count: 155, date: '2019-05-13'},
              {count: 143, date: '2019-05-20'},
              {count: 146, date: '2019-05-27'},
              {count: 145, date: '2019-06-03'},
              {count: 170, date: '2019-06-10'},
              {count: 206, date: '2019-06-17'},
              {count: 219, date: '2019-06-24'},
              {count: 247, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
  };
};
